import { getMetaValue } from './meta'

/**
 * Gets the CSRF token from the meta tag
 *
 * @return {string}
 */
export const getCSRFToken = () => getMetaValue('csrf-token')
